
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[...alias]",
      function () {
        return require("private-next-pages/articles/[...alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[...alias]"])
      });
    }
  